export enum SortCode {
    All = 'All',
    ActivitiesDetailsPageExploreActivitiesCarousel = 'ActivitiesDetailsPageExploreActivitiesCarousel',
    ActivitiesSsr = 'ActivitiesSsr',
    ActivitiesPoiCarousel = 'ActivitiesPoiCarousel',
    ActivitiesSearchDropdown = 'ActivitiesSearchDropdown',
    CityPageSsrSection = 'CityPageSsrSection',
    ActivitiesHomepageDiscoverPlacesCarousel = 'ActivitiesHomepageDiscoverPlacesCarousel',
    ActivitiesHomepageTopActivitiesCarousel = 'ActivitiesHomepageTopActivitiesCarousel',
    ActivitiesHomepageEmptyStateSearchDropdown = 'ActivitiesHomepageEmptyStateSearchDropdown',
    ActivitiesUniversalCrossSellWidgetOnPropertyPage = 'ActivitiesUniversalCrossSellWidgetOnPropertyPage',
    ActivitiesUniversalCrossSellWidgetOnThankYouPage = 'ActivitiesUniversalCrossSellWidgetOnThankYouPage',
    ActivitiesUniversalCrossSellWidgetOnManageMyBookingPage = 'ActivitiesUniversalCrossSellWidgetOnManageMyBookingPage',
    ActivitiesUniversalCrossSellWidgetOnActivitiesHomePage = 'ActivitiesUniversalCrossSellWidgetOnActivitiesHomePage',
    ActivitiesUniversalCrossSellWidgetOnHomePage = 'ActivitiesUniversalCrossSellWidgetOnHomePage',
    BestOfCity = 'BestOfCity',
    Recommended = 'Recommended',
    ReviewDateTime = 'ReviewDateTime',
    Rating = 'Rating',
    Price = 'Price',
    Default = 'Default',
}
